/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CollectedService } from '../../models/collected-service';

export interface GetCollectedServicesForCientAndDateIdDateGet$Json$Params {
  id_client?: number;
  date: string;
  id: string;
}

export function getCollectedServicesForCientAndDateIdDateGet$Json(http: HttpClient, rootUrl: string, params: GetCollectedServicesForCientAndDateIdDateGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CollectedService>>> {
  const rb = new RequestBuilder(rootUrl, getCollectedServicesForCientAndDateIdDateGet$Json.PATH, 'get');
  if (params) {
    rb.query('id_client', params.id_client, {});
    rb.path('date', params.date, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CollectedService>>;
    })
  );
}

getCollectedServicesForCientAndDateIdDateGet$Json.PATH = '/GetCollectedServicesForCientAndDate/{id}/{date}';
